// product page poup start 
// 🔹 Popup Open
$('body').on('click', '.product_tax---popup-link', function (e) {
  e.preventDefault();
  e.stopPropagation(); // document click ko trigger hone se rokne ke liye
  $('.popup--description--wrapper').addClass('is-popup-active');
  $('body').addClass('popup-active');
});

// 🔹 Popup Close (close button click)
$('body').on('click', '.popup--description--wrapper span.svg--close--wrapper svg.icon.icon-close', function () {
  $('.popup--description--wrapper').removeClass('is-popup-active');
  $('body').removeClass('popup-active');
});

// 🔹 Popup Close (outside click)
$(document).on('click', function (e) {
  let $popup = $('.popup--description--wrapper');

  if (
    $popup.is(':visible') && 
    $(e.target).closest('.popup--description--wrapper').length === 0 && 
    !$(e.target).closest('.product_tax---popup-link').length
  ) {
    $popup.removeClass('is-popup-active');
    $('body').removeClass('popup-active');
  }
});

// product page poup end 
// product page on load selctecd inpt start

 // product page on load selctecd inpt start
 // product page on click selctecd inpt start
$('body').on('click','fieldset.js.product-form__input.product-form__input--pill label',function () {
   
   var getdataVal = $(this).attr('data-val');
   var getVarinatext = $(this).attr('data-variant-text');
   $('.variant--meta--text span.days-text').text(getVarinatext)
    console.log(getdataVal);
    setTimeout(function() {
    // $('quantity-input.quantity input.quantity__input').val(getdataVal);
    $('body').attr('qunaity',getdataVal)
    
     }, 200);
  
})
// product page on click selctecd inpt start
// product page on subscription start
$('body').on('click', 'ul.selling-plan--wrapper li', function () {
    if (!$('input[name="purchase_type"][value="subscription"]').is(':checked')) {
        return;
    }

    $('ul.selling-plan--wrapper li').removeClass('active');

    var groupListval = $(this).attr('data-plan-id');
    var groupActualprice = $(this).attr('data-actual-price');
    var groupDiscountedprice = $(this).attr('data-discounted-price');
    var getDiscountvalue = $(this).attr('data-discount-percent');

    console.log(groupListval + '--' + groupActualprice + '--' + groupDiscountedprice);

    $('span.discounted--percenatge').text(getDiscountvalue + '%');
    $('.subscription--price--wrapper span.diswcounted--price')
        .html('€' + groupDiscountedprice + '/ <sub>BTL</sub>');
    $('.subscription--price--wrapper .orignal--price')
        .html('€' + groupActualprice);

    $(this).addClass('active');
    $('input#selected-selling-plan').val(groupListval);
});

$('body').on('click', '.option.subscription', function () {
    var $wrapper = $('ul.selling-plan--wrapper');

    if (!$wrapper.is(':visible')) {
        $wrapper
            .stop(true, true)
            .css({ display: 'flex', overflow: 'hidden', height: 0 }) // flex start
            .animate({ height: $wrapper.get(0).scrollHeight }, 300, function () {
                $(this).css({ height: '', overflow: '' }); // reset height
                $wrapper.find('li:first').trigger('click');
            });
    }
});


$('body').on('click', '.option.one-time', function () {
$('ul.selling-plan--wrapper').hide();
$('.subscription--price--wrapper span.orignal--price').text('');
$('.subscription--price--wrapper span.diswcounted--price').text('');
});
// product page on subscription end
// german lan
$(document).ready(function () {
  // English → German dictionary
  var translations = {
    "Write Review": "Bewertung schreiben",
    "Write a review": "Eine Bewertung schreiben",
    "Sort": "Sortieren",
    "Search:": "Suche:",
    "Search": "Suche",
    "Product Reviews": "Produktbewertungen",
    "Questions": "Fragen",
    "Was this review helpful?": "War diese Bewertung hilfreich?",
    "Yes": "Ja",
    "Report": "Melden",
    "Share": "Teilen",
    "Submit": "Absenden",
    "Cancel": "Abbrechen",
    "Ask Question":"Frage stellen"
  };

  // Function to apply translations
  function applyTranslations() {
    $("body *").each(function () {
      if ($(this).children().length === 0) {
        var text = $(this).text().trim();
        if (translations[text]) {
          $(this).text(translations[text]);
        }
      }
    });
  }

  // Run once on page load
  applyTranslations();

  // Watch for any changes inside body
  const observer = new MutationObserver(function () {
    applyTranslations();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});
// quanity box
let isFirstClick = true;  // Flag to check if it's the first click

$('body').on('click', '.cust-quantity .quantiy-box', function () {
    var getvartext = $(this).attr('data-price-text');
    $('span.days-text').text(getvartext);
    if(getvartext != ""){
    $('.variant--meta--text').show();
    }
    // Remove the 'active' class from all quantity boxes and add it to the clicked one
    $('.cust-quantity .quantiy-box').removeClass('active');
    $(this).addClass('active');

    // Get the selected quantity and actual quantity
    var getQty = $(this).attr('data-qty');

    var getactualqty = $(this).attr('data-actul-qty');  // Actual quantity to be used in multiplication
    
    // Get the product actual price from the data attribute
    var getproductActualprice = $(this).parents('.custom-quantity.custom-quantity').attr('data-product-actual-price');
     var getproductActualcompareprice = $('.quantiy-box:first').attr('data-complare-prce');
    // Debugging: Check what value we're getting for the price
    console.log('Product Actual Price:', getproductActualprice);

    // If the price is undefined or empty, we exit the function
    if (!getproductActualprice) {
        console.error('Error: Product actual price not found!');
        return;
    }

 if (!getproductActualcompareprice) {
        console.error('Error: Product actual price not found!');
        return;
    }
    // Remove the currency symbol (€) and commas from the price, then parse it as a float
    var priceWithoutCurrency = getproductActualprice.replace('€', '').replace(',', '.');  // Handle decimal points correctly
    var priceWithoutCurrency1 = getproductActualcompareprice.replace('€', '').replace(',', '.');  // Handle decimal points correctly
    var productPrice = parseFloat(priceWithoutCurrency);
  var productPrice1 = parseFloat(priceWithoutCurrency1);
    // Check if price conversion was successful
    if (isNaN(productPrice)) {
        console.error('Error: Unable to parse product price.');
        return;
    }
 if (isNaN(productPrice1)) {
        console.error('Error: Unable to parse product price.');
        return;
    }
    // Calculate the total price using getQty (old calculation)
    var totalPriceQty = productPrice * getQty;  // Multiply with getQty (old)
    totalPriceQty = totalPriceQty.toFixed(2);  // Round to 2 decimal places
var totalPriceQty1 = productPrice1 * getQty;  // Multiply with getQty (old)
    totalPriceQty1 = totalPriceQty1.toFixed(2);
    // Calculate the total price using getactualqty (new calculation)
    var totalPriceActual = productPrice * getactualqty;  // Multiply with getactualqty (new)
    totalPriceActual = totalPriceActual.toFixed(2);  // Round to 2 decimal places

    console.log('Total Price (using getQty):', totalPriceQty);  // Log total price for getQty
    console.log('Total Price (using getactualqty):', totalPriceActual);  // Log total price for getactualqty
    
    // Custom formatting: '€89,97 EUR' format
    function formatCurrencyWithEUR(price) {
        // Check if the price already contains € and EUR
        if (price.includes('€') && price.includes('EUR')) {
            return price.replace('.', ',');  // Simply replace the decimal point with a comma
        } else if (price.includes('€')) {
            return price.replace('.', ',') + ' EUR';  // Add EUR if € is already present
        } else if (price.includes('EUR')) {
            return '€' + price.replace('.', ',');  // Add € if EUR is already present
        } else {
            return '€' + price.replace('.', ',') + ' EUR';  // Normal case: add both € and EUR
        }
    }

    // Check if it's the first click
   if (isFirstClick) {
    // On the first click, use the data-compare-price
    var comparePrice = $(this).attr('data-compare-price');  // Get the compare price attribute

    if (comparePrice) {
        // Apply the compare price on the first click
        $('span.price-item.price-item--sale.price-item--last').text(formatCurrencyWithEUR(comparePrice));
    } else {
        console.warn('No compare price found!');
    }

    // After the first click, set isFirstClick to false
    isFirstClick = false;
} else {
    if ($('.price-item.price-item--regular').text().trim() !== '') {
        $('.price-item.price-item--regular').text(formatCurrencyWithEUR(totalPriceQty1));
    }
}

// 🔹 Calculate discount
var discountPercentage = 0;
console.log(totalPriceQty1 + '---' + totalPriceQty);

if (totalPriceQty1 && totalPriceQty) {
    discountPercentage = ((totalPriceQty1 - totalPriceQty) / totalPriceQty1) * 100;
    discountPercentage = Math.floor(discountPercentage); // Round down
}

if (discountPercentage > 0) {
    $('span.discount--prices span.discounted-price').text(discountPercentage + '%');
}


   if (!totalPriceActual || isNaN(totalPriceActual) || totalPriceActual === 'NaN') {
   
    var fallbackComparePrice = $(this).parents('.cust-quantity').find('.quantiy-box:first').attr('data-complare-prce');

    if (fallbackComparePrice) {
       if ($('.price-item.price-item--regular').text().trim() !== '') {
        $('s.price-item.price-item--regular').text(formatCurrencyWithEUR(fallbackComparePrice));
       }
        $('span.price-item.price-item--sale.price-item--last').text(formatCurrencyWithEUR(totalPriceQty));
        console.log(totalPriceQty+'gtjhj')
    } else {
        console.warn('No fallback compare price found!');
    }
} else {
   
    $('span.price-item.price-item--sale.price-item--last').text(formatCurrencyWithEUR(totalPriceActual));
}

    var discountPercentage = 0;
    console.log(totalPriceQty1 +'---'+totalPriceActual)
    if (totalPriceQty1 && totalPriceActual) {
        discountPercentage = ((totalPriceQty1 - totalPriceActual) / totalPriceQty1) * 100;
       discountPercentage = Math.floor(discountPercentage);// Round to two decimal places
    }

    if (discountPercentage > 0) {
      $('span.discount--prices span.discounted-price').text(discountPercentage+'%')
            
    }

    $('.product__info-wrapper .price-per-item__container input.quantity__input').val(getQty);
});
   setTimeout(function() {
$('.cust-quantity .quantiy-box:first').trigger('click')
}, 200);